package com.milta.feature.team.domain.usecase

import com.milta.feature.team.domain.entity.Driver
import com.milta.feature.team.domain.repository.TeamRepository

class GetEnterpriseDriversUseCase(private val repository: TeamRepository) {
    suspend operator fun invoke(enterpriseId: String): Result<List<Driver>> = repository.getDrivers(enterpriseId)
}
